import {
    Box, Container, Grid, IconButton, Typography, TextField, Button, InputLabel, Divider, FormGroup, FormControlLabel,
    Checkbox, Table, TableHead, TableRow, TableCell, TableContainer, CircularProgress, TableBody
} from "@mui/material";
import { useNavigate } from "react-router";
import { useTheme } from "@mui/material/styles";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SaveIcon from '@mui/icons-material/Save';
import { useForm, Controller } from "react-hook-form";
import { useUtiles } from "../../../../shared/context/utilesContext";
import CrearPermisosComponent from "../components/CrearPermisosComponent";
import { useAuth } from "../../../../shared/context/authContext";
import { useEffect } from "react";
import { useParams } from "react-router";
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded';
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import DeleteForeverRoundedIcon from '@mui/icons-material/DeleteForeverRounded';
import { useAbility } from "../../../../shared/context/AbilityContext";

export default function CreateRolView() {
    const theme = useTheme();
    const navigate = useNavigate();
    const { toogleOpenSilder } = useUtiles();
    const { roleUser, setRoleUser, loadingGetRole, getRoleByHashCode, loadingCreateRole,
        createRole, updateRoleExist, loadingUpdateRole, getPermissionsByRole, permissions, loadingGetPermissions, permission, setPermission, deletePermissionByRole, loadingDeletePermission, deleteRole, loadingDeleteRole } = useAuth();
    const { hashCode } = useParams();
    const { control, handleSubmit, setValue, formState: { errors, isValid } } = useForm({
        mode: 'onChange'
    });

    const ability = useAbility();
    useEffect(() => {

        if (!ability.can('create', 'ROLES') && !ability.can('update', 'ROLES')) {
            navigate('/')
        }
    }, [ability])

    useEffect(() => {
        const getRole = async () => {
            if (hashCode) {
                const role = await getRoleByHashCode(hashCode);
                if (role) {
                    setValue('name', role.name);
                    setValue('description', role.description);
                    setValue('view_only_ot_assigned', role.view_only_ot_assigned);
                    setValue('allow_campus_all', role.allow_campus_all);
                    setValue('user_task_attender', role.user_task_attender);
                    setValue('user_task_manager', role.user_task_manager);
                    setValue('can_finish_ot', role.can_finish_ot);
                    setValue('can_return_ot_pending', role.can_return_ot_pending);
                    setValue('can_reassing_ot', role.can_reassing_ot);
                    setRoleUser(role);
                }
            }
            if (hashCode) {
                getPermissionsByRole(hashCode);
            }
        }
        getRole();
    }, [hashCode]);


    const onChangeInput = (key, value) => {
        setRoleUser({ ...roleUser, [key]: value });
        setValue(key, value);
    }

    const onSubmit = (data) => {
        console.log(data);
        if (hashCode) {
            updateRoleExist(data);
        } else {
            createRole(data);
        }
    }


    const handleEditPermission = (permission) => {
        const permissionData = {
            id: permission.id,
            name: permission.name,
            section_hash_code: permission.section,
            actions: permission.actions
        }
        setPermission(permissionData);
        toogleOpenSilder(<CrearPermisosComponent />, 500, 'Crear Permiso');
    }



    return (
        <Container maxWidth="xl" sx={{
            padding: '0px', margin: '0px',
        }}>
            <form onSubmit={handleSubmit(onSubmit)}>

                <Box sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '20px'
                }}>
                    <IconButton
                        onClick={() => navigate('/rrhh/roles')}
                        sx={{
                            borderRadius: '12px',
                            padding: '8px',
                            backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.05)' : 'rgba(0, 0, 0, 0.03)',
                            transition: 'all 0.2s',
                            "&:hover": {
                                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.05)',
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        <ArrowBackIcon />
                    </IconButton>

                    <Button
                        variant="contained"
                        startIcon={loadingCreateRole ? <CircularProgress size={20} /> : <SaveIcon />}
                        type='submit'
                        disabled={!isValid || loadingCreateRole || loadingUpdateRole}
                        sx={{
                            borderRadius: '8px',
                            padding: '8px 25px',
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText,
                            borderRadius: '50px',
                            transition: 'all 0.2s',

                            "&:hover": {
                                backgroundColor: theme.palette.primary.dark,
                                transform: 'translateY(-2px)'
                            }
                        }}
                    >
                        {loadingCreateRole || loadingUpdateRole ? <CircularProgress size={20} /> : hashCode ? 'Actualizar' : 'Guardar'}
                    </Button>
                </Box>


                <Box sx={{
                    borderRadius: '10px',
                    backgroundColor: theme.palette.background.paper,
                    padding: '20px',
                    position: 'relative'
                }}>

                    <Grid container spacing={2}>
                        <Grid item size={{ xs: 12 }}>
                            <InputLabel sx={{ color: 'text.primary', fontWeight: 'bold' }}>Nombre del rol</InputLabel>
                            <Typography variant="caption" sx={{ color: 'text.secondary' }}>El nombre del rol debe ser único y no puede contener espacios ni caracteres especiales (solo letras y números)</Typography>
                            <Controller
                                control={control}
                                name="name"
                                rules={{
                                    required: "El nombre del rol es requerido",
                                    maxLength: {
                                        value: 20,
                                        message: "El nombre no puede tener más de 20 caracteres"
                                    },
                                    pattern: {
                                        value: /^[a-zA-Z0-9]+$/,
                                        message: "No se permiten espacios ni caracteres especiales"
                                    }
                                }}
                                render={({ field }) => (
                                    <TextField
                                        {...field}
                                        fullWidth
                                        required
                                        error={!!errors.name}
                                        helperText={errors.name?.message}
                                        onChange={(e) => {
                                            field.onChange(e);
                                            onChangeInput('name', e.target.value);
                                        }}
                                    />
                                )}
                            />
                        </Grid>
                        <Grid item size={{ xs: 12 }}>
                            <InputLabel sx={{ color: 'text.primary', fontWeight: 'bold' }}>Descripción del rol (Opcional)</InputLabel>
                            <Controller
                                control={control}
                                name="description"
                                render={({ field }) => (
                                    <TextField fullWidth {...field} onChange={(e) => {
                                        field.onChange(e);
                                        onChangeInput('description', e.target.value);
                                    }} multiline rows={2}
                                    />
                                )}
                            />
                        </Grid>

                        {!hashCode && <Grid item size={{ xs: 12 }}>
                            <Typography variant="subtitle1" sx={{ color: 'text.secondary', textAlign: 'center' }}>Primero debes crear el rol para poder agregar permisos</Typography>
                        </Grid>}


                        <Grid item size={{ xs: 12, md: 4 }} sx={{ opacity: !hashCode ? 0.5 : 1 }}>
                            <Divider textAlign="left">
                                <Typography variant="subtitle1" >Condiciones</Typography>
                            </Divider>

                            <FormGroup>
                                <Controller
                                    name="view_only_ot_assigned"
                                    control={control}
                                    defaultValue={false}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    {...field}
                                                    checked={field.value}
                                                    disabled={!hashCode}
                                                    onChange={(e) => {
                                                        field.onChange(e.target.checked);
                                                        onChangeInput('view_only_ot_assigned', e.target.checked);
                                                    }}
                                                />
                                            }
                                            label="Solo visualizar OTs asignadas"
                                        />
                                    )}
                                />
                                <Controller
                                    name="allow_campus_all"
                                    control={control}
                                    defaultValue={false}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    {...field}
                                                    checked={field.value}
                                                    disabled={!hashCode}
                                                    onChange={(e) => {
                                                        field.onChange(e.target.checked);
                                                        onChangeInput('allow_campus_all', e.target.checked);
                                                    }}
                                                />
                                            }
                                            label="Usuario disponible en todas las sedes"
                                        />
                                    )}
                                />
                                <Controller
                                    name="user_task_attender"
                                    control={control}
                                    defaultValue={false}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    {...field}
                                                    checked={field.value}
                                                    disabled={!hashCode}
                                                    onChange={(e) => {
                                                        field.onChange(e.target.checked);
                                                        onChangeInput('user_task_attender', e.target.checked);
                                                    }}
                                                />
                                            }
                                            label="Usuario que atiende OTs"
                                        />
                                    )}
                                />
                                <Controller
                                    name="user_task_manager"
                                    control={control}
                                    defaultValue={false}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    {...field}
                                                    checked={field.value}
                                                    disabled={!hashCode}
                                                    onChange={(e) => {
                                                        field.onChange(e.target.checked);
                                                        onChangeInput('user_task_manager', e.target.checked);
                                                    }}
                                                />
                                            }
                                            label="Usuario que gestiona tareas y OTs"
                                        />
                                    )}
                                />

                                <Controller
                                    name="can_finish_ot"
                                    control={control}
                                    defaultValue={false}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    {...field}
                                                    checked={field.value}
                                                    disabled={!hashCode}
                                                    onChange={(e) => {
                                                        field.onChange(e.target.checked);
                                                        onChangeInput('can_finish_ot', e.target.checked);
                                                    }}
                                                />
                                            }
                                            label="Puede finalizar OTs"
                                        />
                                    )}
                                />

                                <Controller
                                    name="can_return_ot_pending"
                                    control={control}
                                    defaultValue={false}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    {...field}
                                                    checked={field.value}
                                                    disabled={!hashCode}
                                                    onChange={(e) => {
                                                        field.onChange(e.target.checked);
                                                        onChangeInput('can_return_ot_pending', e.target.checked);
                                                    }}
                                                />
                                            }
                                            label="Puede retornar OTs a estado pendiente"
                                        />
                                    )}
                                />

                                <Controller
                                    name="can_reassing_ot"
                                    control={control}
                                    defaultValue={false}
                                    render={({ field }) => (
                                        <FormControlLabel
                                            control={
                                                <Checkbox
                                                    {...field}
                                                    checked={field.value}
                                                    disabled={!hashCode}
                                                    onChange={(e) => {
                                                        field.onChange(e.target.checked);
                                                        onChangeInput('can_reassing_ot', e.target.checked);
                                                    }}
                                                />
                                            }
                                            label="Puede reasignar OTs"
                                        />
                                    )}
                                />
                            </FormGroup>

                        </Grid>
                        <Grid item size={{ xs: 12, md: 8 }} sx={{ opacity: !hashCode ? 0.5 : 1 }}>
                            <Divider textAlign="left">
                                <Typography variant="subtitle1">Permisos</Typography>
                            </Divider>

                            <TextField
                                disabled={!hashCode}
                                onClick={() => {
                                    toogleOpenSilder(<CrearPermisosComponent />, 500, 'Crear Permiso');
                                    setPermission({
                                        name: '',
                                        section_hash_code: '',
                                        actions: []
                                    })
                                }}
                                fullWidth
                                placeholder="Agregar permiso"
                                slotProps={{
                                    input: {
                                        readOnly: true,
                                    }
                                }}
                                sx={{
                                    cursor: 'pointer',
                                    "&:hover": {
                                        backgroundColor: theme.palette.action.hover,
                                    }
                                }}
                            />

                            <TableContainer sx={{ height: "400px", overflow: "auto", marginTop: '10px' }}>
                                <Table stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell></TableCell>
                                            <TableCell>Nombre</TableCell>
                                            <TableCell>Módulo</TableCell>
                                            <TableCell>C</TableCell>
                                            <TableCell>R</TableCell>
                                            <TableCell>U</TableCell>
                                            <TableCell>D</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {permissions.map((permission) => (
                                            <TableRow key={permission.hash_code}>
                                                <TableCell sx={{ width: '100px' }}>
                                                    <Box sx={{ display: 'flex', gap: 1 }}>
                                                        <IconButton
                                                            onClick={() => deletePermissionByRole(permission.id)}
                                                            size="small"
                                                            sx={{
                                                                backgroundColor: '#f44336',
                                                                color: '#fff',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(244, 67, 54, 0.08)'
                                                                }
                                                            }}
                                                        >
                                                            <DeleteRoundedIcon />
                                                        </IconButton>
                                                        <IconButton
                                                            size="small"
                                                            onClick={() => handleEditPermission(permission)}
                                                            sx={{
                                                                backgroundColor: '#ffc107',
                                                                color: '#fff',
                                                                '&:hover': {
                                                                    backgroundColor: 'rgba(255, 193, 7, 0.08)'
                                                                }
                                                            }}
                                                        >
                                                            <EditRoundedIcon />
                                                        </IconButton>
                                                    </Box>
                                                </TableCell>
                                                <TableCell>{permission.name}</TableCell>
                                                <TableCell>{permission.section.name}</TableCell>
                                                <TableCell>{permission.actions.includes('create') ? <CheckCircleRoundedIcon color="primary" /> : <CancelRoundedIcon sx={{ opacity: 0.2 }} />}</TableCell>
                                                <TableCell>{permission.actions.includes('read') ? <CheckCircleRoundedIcon color="primary" /> : <CancelRoundedIcon sx={{ opacity: 0.2 }} />}</TableCell>
                                                <TableCell>{permission.actions.includes('update') ? <CheckCircleRoundedIcon color="primary" /> : <CancelRoundedIcon sx={{ opacity: 0.2 }} />}</TableCell>
                                                <TableCell>{permission.actions.includes('delete') ? <CheckCircleRoundedIcon color="primary" /> : <CancelRoundedIcon sx={{ opacity: 0.2 }} />}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                        </Grid>

                        <Grid item size={{ xs: 12 }}>
                            <Divider textAlign="left" sx={{ marginBottom: '10px' }}>
                            </Divider>
                            <Button variant="contained" color="primary" startIcon={<DeleteRoundedIcon />} sx={{ borderRadius: '50px', backgroundColor: '#f44336', color: '#fff' }}
                                onClick={() => deleteRole(hashCode)}
                                disabled={loadingDeleteRole}
                            >
                                {loadingDeleteRole ? <CircularProgress size={20} /> : 'Eliminar rol'}
                            </Button>

                        </Grid>
                    </Grid>

                </Box>
            </form>
        </Container>
    )
}